export const COMPARISON_METRICS = [
  { key: "rating", label: "Average rating", format: n => n == null ? "—" : `${n.toFixed(1)} ★` },
  { key: "reviews", label: "Total reviews", format: n => n == null ? "—" : n.toLocaleString("en-GB") },
  { key: "fiveStar", label: "5-star reviews", format: n => n == null ? "—" : `${n}%` },
  { key: "response", label: "Response rate", format: n => n == null ? "—" : `${n}%` },
  { key: "positive", label: "Positive sentiment", format: n => n == null ? "—" : `${n}%` },
  { key: "negative", label: "Negative sentiment", format: n => n == null ? "—" : `${n}%`, lowerIsBetter: true },
  { key: "monthly", label: "Reviews / month", format: n => n == null ? "—" : n.toString() },
];

export function comparableMetricValue(metric, value) {
  if (value == null) return null;
  if (metric.key === "rating") return Number(value.toFixed(1));
  if (["response", "positive", "negative"].includes(metric.key)) return Math.round(value);
  return value;
}

export function compareAdvantage(venue, business, metrics = COMPARISON_METRICS) {
  return metrics.filter(metric => {
    if (venue[metric.key] == null || business[metric.key] == null) return false;
    const venueValue = comparableMetricValue(metric, venue[metric.key]);
    const businessValue = comparableMetricValue(metric, business[metric.key]);
    return metric.lowerIsBetter ? venueValue < businessValue : venueValue > businessValue;
  });
}

export function radarMetrics(venue, business, live = false) {
  if (live) {
    const maxReviews = Math.max(venue.reviews || 0, business.reviews || 0, 1);
    return [
      { metric: "Avg Rating", you: (venue.rating || 0) * 20, competitor: (business.rating || 0) * 20 },
      { metric: "5-star share", you: venue.fiveStar || 0, competitor: business.fiveStar || 0 },
      { metric: "Positive", you: venue.positive || 0, competitor: business.positive || 0 },
      { metric: "Low negative", you: 100 - (venue.negative || 0), competitor: 100 - (business.negative || 0) },
      { metric: "Review volume", you: 100 * (venue.reviews || 0) / maxReviews, competitor: 100 * (business.reviews || 0) / maxReviews },
    ];
  }
  const maxMonthly = Math.max(venue.monthly, business.monthly, 1);
  return [
    { metric: "Rating", you: venue.rating * 20, competitor: business.rating * 20 },
    { metric: "Response", you: venue.response, competitor: business.response },
    { metric: "Positive", you: venue.positive, competitor: business.positive },
    { metric: "Low negative", you: 100 - venue.negative, competitor: 100 - business.negative },
    { metric: "Review pace", you: 100 * venue.monthly / maxMonthly, competitor: 100 * business.monthly / maxMonthly },
  ];
}
